// actions
const SET = "conditions/SET";
const SET_SELECTED = "conditions/SET_SELECTED";
const SET_SELECTED_FILTERS = "conditions/SET_SELECTED_FILTERS";
const DEFAULT_STATE = {
  listing: [],
  selectedFilters: [],
};

// reducer
const reducer = (state = DEFAULT_STATE, action: any = {}) => {
  switch (action.type) {
    case SET:
      return Object.assign({}, state, { listing: action.listing });
    case SET_SELECTED_FILTERS:
      return Object.assign({}, state, { selectedFilters: action.listing });
    case SET_SELECTED:
      return Object.assign({}, state, { selected: action.id });

    default:
      return state;
  }
};
export default reducer;

// action creators
export const setListing = (listing: any[]) => ({ listing, type: SET });
export const setSelected = (id: string) => ({ id, type: SET_SELECTED });
export const setSelectedFilters = (listing: any[]) => ({
  listing,
  type: SET_SELECTED_FILTERS,
});

